import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuthFetch } from "../hooks/useAuthFetch";
import "../stili/PresenzaGaraStaff.css";


const API_URL = process.env.REACT_APP_API_URL;

export default function PresenzaGaraStaff() {
  const authFetch = useAuthFetch();
  const navigate = useNavigate();

  const [eventi, setEventi] = useState([]);
  const [eventoSelezionato, setEventoSelezionato] = useState(null);

  const [gare, setGare] = useState([]);
  const [garaSelezionata, setGaraSelezionata] = useState(null);

  const [dettaglio, setDettaglio] = useState(null);
  const [convocati, setConvocati] = useState([]);

  const [loadingEventi, setLoadingEventi] = useState(false);
  const [loadingGare, setLoadingGare] = useState(false);
  const [loadingDettaglio, setLoadingDettaglio] = useState(false);
  const [saving, setSaving] = useState(false);

  const customSelectStyles = useMemo(
    () => ({
      control: (base, state) => ({
        ...base,
        background: "rgba(255,255,255,0.10)",
        borderColor: state.isFocused
          ? "rgba(255,255,255,0.45)"
          : "rgba(255,255,255,0.20)",
        boxShadow: "none",
        minHeight: "44px",
        borderRadius: "12px",
        color: "#fff",
        backdropFilter: "blur(10px)",
      }),
      menu: (base) => ({
        ...base,
        background: "rgba(15, 23, 52, 0.96)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "12px",
        overflow: "hidden",
        zIndex: 20,
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused
          ? "rgba(255,255,255,0.10)"
          : "transparent",
        color: "#fff",
        cursor: "pointer",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#fff",
      }),
      placeholder: (base) => ({
        ...base,
        color: "rgba(255,255,255,0.70)",
      }),
      input: (base) => ({
        ...base,
        color: "#fff",
      }),
    }),
    []
  );

  useEffect(() => {
  async function fetchEventi() {
    setLoadingEventi(true);
    try {
      const res = await authFetch(`${API_URL}/api/eventi-gara/miei`);
      if (!res.ok) {
        throw new Error("Errore nel caricamento eventi");
      }

      const data = await res.json().catch(() => []);
      const items = Array.isArray(data) ? data : [];

      const options = items.map((ev) => ({
        value: ev.id,
        label: ev.nomeEvento || `Evento #${ev.id}`,
        raw: ev,
      }));

      setEventi(options);
    } catch (err) {
      console.error(err);
      toast.error("Impossibile caricare gli eventi gara");
    } finally {
      setLoadingEventi(false);
    }
  }

  fetchEventi();
}, [authFetch]);

  async function fetchGareByEvento(idEvento) {
    if (!idEvento) return;

    setLoadingGare(true);
    setGare([]);
    setGaraSelezionata(null);
    setDettaglio(null);
    setConvocati([]);

    try {
      const res = await authFetch(
        `${API_URL}/api/staff/presenze-gara/evento/${idEvento}/gare`
      );

      if (!res.ok) {
        throw new Error("Errore nel caricamento gare");
      }

      const data = await res.json().catch(() => []);
      const items = Array.isArray(data) ? data : [];

      const options = items.map((gara) => ({
        value: gara.id,
        label: buildGaraLabel(gara),
        raw: gara,
      }));

      setGare(options);
    } catch (err) {
      console.error(err);
      toast.error("Impossibile caricare le gare dell'evento");
    } finally {
      setLoadingGare(false);
    }
  }

  async function fetchDettaglioGara(idGara) {
    if (!idGara) return;

    setLoadingDettaglio(true);
    setDettaglio(null);
    setConvocati([]);

    try {
      const res = await authFetch(
        `${API_URL}/api/staff/presenze-gara/gara/${idGara}`
      );

      if (!res.ok) {
        throw new Error("Errore nel caricamento dettaglio gara");
      }

      const data = await res.json();
      setDettaglio(data);

      const lista = Array.isArray(data?.convocati)
        ? data.convocati.map((item) => ({
            ...item,
            presente: !!item.presente,
            note: item.note || "",
          }))
        : [];

      setConvocati(lista);
    } catch (err) {
      console.error(err);
      toast.error("Impossibile caricare la lista convocati");
    } finally {
      setLoadingDettaglio(false);
    }
  }

  function buildGaraLabel(gara) {
    const categoria = gara?.categoriaNome || gara?.categoria?.nome || "";
    const avversario = gara?.avversario || "Avversario";
    const data = gara?.dataGara || "";
    const ora = gara?.oraGara ? String(gara.oraGara).slice(0, 5) : "";
    return `${categoria ? categoria + " - " : ""}${avversario} - ${data}${ora ? ` - ${ora}` : ""}`;
  }

  function onSelectEvento(selected) {
    setEventoSelezionato(selected);
    if (selected?.value) {
      fetchGareByEvento(selected.value);
    } else {
      setGare([]);
      setGaraSelezionata(null);
      setDettaglio(null);
      setConvocati([]);
    }
  }

  function onSelectGara(selected) {
    setGaraSelezionata(selected);
    if (selected?.value) {
      fetchDettaglioGara(selected.value);
    } else {
      setDettaglio(null);
      setConvocati([]);
    }
  }

  function aggiornaPresenza(idConvocazioneGiocatore, presente) {
    setConvocati((prev) =>
      prev.map((item) =>
        item.idConvocazioneGiocatore === idConvocazioneGiocatore
          ? { ...item, presente }
          : item
      )
    );
  }

  function aggiornaNota(idConvocazioneGiocatore, note) {
    setConvocati((prev) =>
      prev.map((item) =>
        item.idConvocazioneGiocatore === idConvocazioneGiocatore
          ? { ...item, note }
          : item
      )
    );
  }

  function impostaTuttiPresenti() {
    setConvocati((prev) => prev.map((item) => ({ ...item, presente: true })));
  }

  function impostaTuttiAssenti() {
    setConvocati((prev) => prev.map((item) => ({ ...item, presente: false })));
  }

  async function handleSalva() {
    if (!garaSelezionata?.value) {
      toast.warning("Seleziona prima una gara");
      return;
    }

    setSaving(true);
    try {
      const payload = {
        convocati: convocati.map((item) => ({
          idConvocazioneGiocatore: item.idConvocazioneGiocatore,
          presente: !!item.presente,
          note: item.note || "",
        })),
      };

      const res = await authFetch(
        `${API_URL}/api/staff/presenze-gara/gara/${garaSelezionata.value}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        throw new Error("Errore nel salvataggio");
      }

      const data = await res.json();
      setDettaglio(data);
      setConvocati(
        Array.isArray(data?.convocati)
          ? data.convocati.map((item) => ({
              ...item,
              presente: !!item.presente,
              note: item.note || "",
            }))
          : []
      );

      toast.success("Presenze gara salvate con successo");
    } catch (err) {
      console.error(err);
      toast.error("Errore durante il salvataggio delle presenze");
    } finally {
      setSaving(false);
    }
  }

  const assentiCount = convocati.filter((c) => !c.presente).length;
  const presentiCount = convocati.filter((c) => c.presente).length;

  return (
    <div className="sfondo-immagine">
      <div className="presenza-gara-staff-page">
        <div className="presenza-gara-staff-container">
          <h2 className="presenza-gara-staff-title">Presenze Gara Staff</h2>

          <div className="presenza-gara-staff-filtri">
            <div className="presenza-gara-staff-field">
              <label>Evento gara</label>
              <Select
                options={eventi}
                value={eventoSelezionato}
                onChange={onSelectEvento}
                placeholder={loadingEventi ? "Caricamento eventi..." : "Seleziona evento"}
                isClearable
                isDisabled={loadingEventi}
                styles={customSelectStyles}
              />
            </div>

            <div className="presenza-gara-staff-field">
              <label>Gara</label>
              <Select
                options={gare}
                value={garaSelezionata}
                onChange={onSelectGara}
                placeholder={loadingGare ? "Caricamento gare..." : "Seleziona gara"}
                isClearable
                isDisabled={!eventoSelezionato || loadingGare}
                styles={customSelectStyles}
              />
            </div>
          </div>

          {loadingDettaglio && (
            <div className="presenza-gara-staff-info-card">
              <p>Caricamento dettaglio gara...</p>
            </div>
          )}

          {dettaglio && !loadingDettaglio && (
            <>
              <div className="presenza-gara-staff-header-card">
                <div className="presenza-gara-staff-header-grid">
                  <div>
                    <span className="label">Evento</span>
                    <strong>{dettaglio.nomeEvento || "-"}</strong>
                  </div>
                  <div>
                    <span className="label">Avversario</span>
                    <strong>{dettaglio.avversario || "-"}</strong>
                  </div>
                  <div>
                    <span className="label">Data gara</span>
                    <strong>{dettaglio.dataGara || "-"}</strong>
                  </div>
                  <div>
                    <span className="label">Ora gara</span>
                    <strong>
                      {dettaglio.oraGara ? String(dettaglio.oraGara).slice(0, 5) : "-"}
                    </strong>
                  </div>
                  <div>
                    <span className="label">Categoria gara</span>
                    <strong>{dettaglio.categoriaGara || "-"}</strong>
                  </div>
                  <div>
                    <span className="label">Ora appuntamento</span>
                    <strong>
                      {dettaglio.oraAppuntamento
                        ? String(dettaglio.oraAppuntamento).slice(0, 5)
                        : "-"}
                    </strong>
                  </div>
                  <div>
                    <span className="label">Luogo</span>
                    <strong>{dettaglio.luogo || "-"}</strong>
                  </div>
                  <div>
                    <span className="label">Indirizzo</span>
                    <strong>{dettaglio.indirizzo || "-"}</strong>
                  </div>
                </div>

                {dettaglio.noteConvocazione && (
                  <div className="presenza-gara-staff-note-box">
                    <span className="label">Note convocazione</span>
                    <p>{dettaglio.noteConvocazione}</p>
                  </div>
                )}
              </div>

              <div className="presenza-gara-staff-toolbar">
                <div className="presenza-gara-staff-stats">
                  <span>Convocati: {convocati.length}</span>
                  <span>Presenti: {presentiCount}</span>
                  <span>Assenti: {assentiCount}</span>
                </div>

                <div className="presenza-gara-staff-actions-inline">
                  <button
                    type="button"
                    className="btn-secondario"
                    onClick={impostaTuttiPresenti}
                  >
                    Tutti presenti
                  </button>
                  <button
                    type="button"
                    className="btn-secondario"
                    onClick={impostaTuttiAssenti}
                  >
                    Tutti assenti
                  </button>
                </div>
              </div>

              <div className="presenza-gara-staff-lista">
                {convocati.length === 0 ? (
                  <div className="presenza-gara-staff-info-card">
                    <p>Nessun convocato presente per questa gara.</p>
                  </div>
                ) : (
                  convocati.map((item) => (
                    <div
                      key={item.idConvocazioneGiocatore}
                      className={`presenza-gara-staff-player-card ${
                        item.presente ? "is-presente" : "is-assente"
                      }`}
                    >
                      <div className="presenza-gara-staff-player-top">
                        <div>
                          <h3 className={!item.presente ? "presenza-gara-staff-player-name assente" : "presenza-gara-staff-player-name"}>
                            {item.cognome} {item.nome}
                          </h3>
                          <p>
                            Categoria giocatore:{" "}
                            <strong>{item.categoriaGiocatore || "-"}</strong>
                          </p>
                          <p>
                            Titolare:{" "}
                            <strong>{item.titolare ? "Sì" : "No"}</strong>
                          </p>
                        </div>

                        <div className="presenza-gara-staff-toggle">
                          <button
                            type="button"
                            className={item.presente ? "toggle-btn active" : "toggle-btn"}
                            onClick={() =>
                              aggiornaPresenza(item.idConvocazioneGiocatore, true)
                            }
                          >
                            Presente
                          </button>
                          <button
                            type="button"
                            className={!item.presente ? "toggle-btn active" : "toggle-btn"}
                            onClick={() =>
                              aggiornaPresenza(item.idConvocazioneGiocatore, false)
                            }
                          >
                            Assente
                          </button>
                        </div>
                      </div>

                      <div className="presenza-gara-staff-note-field">
                        <label>Note</label>
                        <textarea
                          value={item.note}
                          onChange={(e) =>
                            aggiornaNota(item.idConvocazioneGiocatore, e.target.value)
                          }
                          rows={2}
                          placeholder="Inserisci eventuali note"
                        />
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div className="presenza-gara-staff-actions-final">
  <button
    type="button"
    className="presenza-gara-staff-btn-secondario"
    onClick={() => navigate(-1)}
  >
    Torna al Gestionale
  </button>

  <button
    type="button"
    className="presenza-gara-staff-btn-primario"
    onClick={handleSalva}
    disabled={saving}
  >
    {saving ? "Salvataggio..." : "Salva presenze"}
  </button>
</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}